module.exports = __webpack_public_path__ + "static/media/DISCLAIMER - Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.a6dacbc1.pdf";